/*!
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
/**
 * @module public
 */
import { loadState } from '@nextcloud/initial-state';
/**
 * Check if the current page is on a public share
 */
export function isPublicShare() {
    // check both the new initial state version and fallback to legacy input
    return (loadState('files_sharing', 'isPublic', null)
        ?? document.querySelector('input#isPublic[type="hidden"][name="isPublic"][value="1"]') !== null);
}
/**
 * Get the sharing token for the current public share
 */
export function getSharingToken() {
    return (loadState('files_sharing', 'sharingToken', null)
        ?? document.querySelector('input#sharingToken[type="hidden"]')?.value
        ?? null);
}
